import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ILengthAlertBehavior } from "../../../../documaker/domain/format/objects";

export interface ILengthAlertBehaviorPropertyEditable {
  lengthAlertBehavior(): IPropertyEditable<ILengthAlertBehavior>;
}

export function instanceOfILengthAlertBehaviorPropertyEditable(instance: any): instance is ILengthAlertBehaviorPropertyEditable {
  return instance
      && instance.lengthAlertBehavior
      && instanceOfIPropertyEditable<ILengthAlertBehavior>(instance.lengthAlertBehavior());
}
